import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTemplateIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.75 0H4.75C2.13 0 0 2.13 0 4.75V12.75C0 15.37 2.13 17.5 4.75 17.5H14.75C17.37 17.5 19.5 15.37 19.5 12.75V4.75C19.5 2.13 17.37 0 14.75 0ZM8.5 5.5H18V10H8.5V5.5ZM4.75 1.5H14.75C16.28 1.5 17.56 2.57 17.9 4H1.6C1.94 2.57 3.22 1.5 4.75 1.5ZM1.5 12.75V5.5H7V16H4.75C2.96 16 1.5 14.54 1.5 12.75ZM14.75 16H8.5V11.5H18V12.75C18 14.54 16.54 16 14.75 16Z",
		fill: "currentColor"
	})
});
export default SvgTemplateIcon;
